import React from 'react'
import Helmet from 'react-helmet'
import Navbar from './Navbar'
import NavbarDesktop from './NavbarDesktop'
import './all.sass'

const TemplateWrapper = ({ children }) => (
  <div>    
    <Helmet title="BH Telecom - SFF" />
    <NavbarDesktop />
    <div>{children}</div>
    <Navbar />
  </div>
)

export default TemplateWrapper
